import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import { SummaryCardHelp } from '~/modules/common/components';

const HEADER_CONFIG = {
  workingTime: {
    labelId:
      'resourceManagementDashboard.benchOverAllocationTracker.table.workingTime',
    tooltipDescriptionId: 'working-time-tooltip-description',
    tooltipContent: [
      {
        key: 'workingTime',
        message: (
          <FormattedMessage id="resourceManagementDashboard.benchOverAllocationTracker.table.workingTimeTooltipFormula" />
        )
      }
    ]
  },
  targetUtilization: {
    labelId:
      'resourceManagementDashboard.benchOverAllocationTracker.table.targetUtilization',
    tooltipDescriptionId: 'target-utilization-tooltip-description',
    tooltipContent: [
      {
        key: 'targetUtilization',
        title: (
          <FormattedMessage id="resourceManagementDashboard.benchOverAllocationTracker.table.targetUtilization" />
        ),
        message: (
          <FormattedMessage id="resourceManagementDashboard.benchOverAllocationTracker.table.targetUtilizationTooltipFormula" />
        )
      }
    ]
  },
  fittingAllocation: {
    labelId:
      'resourceManagementDashboard.benchOverAllocationTracker.table.fittingAllocation',
    tooltipDescriptionId: 'fitting-allocation-tooltip-description',
    tooltipContent: [
      {
        key: 'fittingAllocation',
        message: (
          <FormattedMessage id="resourcingOverviewChart.tooltips.fittingAllocation" />
        )
      }
    ]
  }
};

const useHeaderContainerStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    [theme.breakpoints.down('xs')]: {
      fontSize: theme.typography.caption.fontSize,
      whiteSpace: 'initial'
    }
  }
}));

const useTooltipStyles = makeStyles(theme => ({
  helpIcon: {
    paddingBottom: theme.spacing(0.5)
  }
}));

const HeaderWithTooltip = ({
  labelId,
  tooltipContent,
  tooltipDescriptionId
}) => {
  const classes = useHeaderContainerStyles();
  const tooltipClasses = useTooltipStyles();
  const { formatMessage } = useIntl();

  const iconAriaLabel = formatMessage({
    id: 'resourceManagementDashboard.benchOverAllocationTracker.table.helpIcon'
  });

  return (
    <div className={classes.container}>
      <FormattedMessage id={labelId} />
      <SummaryCardHelp
        classes={tooltipClasses}
        tooltipVariant="v5"
        content={tooltipContent}
        iconAriaLabel={iconAriaLabel}
        tooltipDescriptionId={tooltipDescriptionId}
      />
    </div>
  );
};

HeaderWithTooltip.propTypes = {
  labelId: PropTypes.string.isRequired,
  tooltipContent: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      title: PropTypes.node,
      message: PropTypes.node.isRequired
    })
  ).isRequired,
  tooltipDescriptionId: PropTypes.string.isRequired
};

export const WorkingHoursHeader = () => (
  <HeaderWithTooltip {...HEADER_CONFIG.workingTime} />
);

export const TargetUtilizationHeader = () => (
  <HeaderWithTooltip {...HEADER_CONFIG.targetUtilization} />
);

export const FittingAllocationHeader = () => (
  <HeaderWithTooltip {...HEADER_CONFIG.fittingAllocation} />
);
